import React from "react";
import { Route, Routes } from "react-router-dom";

// import pages
import Home from "../home/Home";
import About from "../about/About";
import Careers from "../careers/Careers";
import Contact from "../contact/Contact";
import Login from "../auth/Login";
import CareerDetail from "../careers/CareerDetail";
import PrivacyPolicy from "../privacy/PrivacyPolicy";
import NotFound from "../notfound/NotFound";
import Product from "../product/Product";

const Main = () => {
  return (
    <div>
      <Routes>
        <Route path="/" element={<Home title="" />} />
        <Route path="/about" element={<About title="About" />} />
        <Route path="/careers" element={<Careers title="Careers" />} />{" "}
        <Route
          path="/careers/:slug"
          element={<CareerDetail title="Career Detail" />}
        />
        <Route path="/contact" element={<Contact title="Contact" />} />
        <Route path="/product" element={<Product title="Resume Builder" />} />
        <Route path="/login" element={<Login title="Login" />} />
        <Route
          path="/privacy-policy"
          element={<PrivacyPolicy title="Privacy Policy" />}
        />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  );
};

export default Main;
